import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulbSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLightBulbSimple"><Path d="M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.8408 18.519 15.3353 16.2893 16.7541C16.1857 16.82 16.1084 16.9061 16.0598 17H7.94018C7.89165 16.9061 7.81429 16.82 7.71074 16.7541C5.48105 15.3353 4 12.8408 4 10Z" fill="currentColor"/><Path d="M8 18V19C8 21.2091 9.79086 23 12 23C14.2091 23 16 21.2091 16 19V18H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightBulbSimple;
